import { render, staticRenderFns } from "./import-tatics.vue?vue&type=template&id=6dc93ef1&scoped=true"
import script from "./import-tatics.vue?vue&type=script&lang=ts"
export * from "./import-tatics.vue?vue&type=script&lang=ts"
import style0 from "./import-tatics.vue?vue&type=style&index=0&id=6dc93ef1&prod&lang=less&scoped=true"
import style1 from "./import-tatics.vue?vue&type=style&index=1&id=6dc93ef1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc93ef1",
  null
  
)

export default component.exports